<template>
  <v-card style="overflow: auto" tile flat>
    <v-card-title class="text-h6 orange lighten-5">
      Retards et départs
      <v-spacer></v-spacer>
      <v-btn small color="green" dark @click="openAddDialog">
        <v-icon left small>mdi-plus</v-icon>
        Ajouter
      </v-btn>
    </v-card-title>
    <v-dialog v-model="dialog" max-width="600px">
      <record-form
        :formTitle="formTitle"
        :record="editedCheckin"
        :items="types"
        selectLabel="* Type"
        selectField="type"
        :workingDays="workingDays"
        @save="handleSaveCheckin"
        @cancel="dialog = false"
      ></record-form>
    </v-dialog>
    <v-data-table
      item-key="checkins.key"
      :loading="loading"
      :headers="headers"
      :items="checkins"
      :no-data-text="'Aucun retard ou départ'"
      class="mytable_checkins"
      indeterminate
      sort-by="id"
      sort-desc
      :items-per-page="-1"
      hide-default-footer
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.date | dateToHuman }}</td>
            <td>{{ item.statusLabel }}</td>
            <td>{{ item.comment }}</td>
            <td class="spacy">
              <v-btn text icon color="green" @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn text icon color="red" @click="deleteItem(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Checkin from "@/models/Checkin"
import StudentCourse from "@/models/StudentCourse"
import Course from "@/models/Course"
import RecordForm from "@/components/common/RecordForm"
import { notify } from "@/services/notification"

export default {
  components: {
    RecordForm,
  },
  async mounted() {
    await this.getDataFromApi()
    this.updateCheckins()
    this.loading = false
  },
  watch: {
    student_course_id: async function () {
      this.updateCheckins()
    },
  },
  props: {
    student_course_id: {
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    editedCheckin: null,
    checkins: [],
    formTitle: "Ajouter un retard/départ",
    headers: [
      { text: "Date", value: "date", align: "left", width: "120px" },
      { text: "Type", value: "type", align: "left", width: "200px" },
      { text: "Commentaire", value: "comment" },
      { text: "Actions", value: "actions", sortable: false, width: "100px" },
    ],
    loading: true,
  }),
  computed: {
    types() {
      return Checkin.types()
    },
    workingDays() {
      const sc = StudentCourse.find(this.student_course_id)
      if (sc?.course_id) {
        const course = Course.find(sc.course_id)
        return course?.working_days || []
      }
      return []
    },
  },
  methods: {
    async getDataFromApi() {
      this.loading = true
      await Checkin.getByStudentCourseId(this.student_course_id)
      this.loading = false
    },
    openAddDialog() {
      this.formTitle = "Ajouter un retard/départ"
      this.editedCheckin = {
        student_course_id: this.student_course_id,
        date: "",
        type: "",
        comment: "",
      }
      this.dialog = true
    },
    editItem(item) {
      this.formTitle = "Modifier un retard/départ"
      this.editedCheckin = { ...item }
      this.dialog = true
    },
    deleteItem(item) {
      confirm("Êtes-vous sûr de vouloir supprimer cette donnée?") &&
        (this.loading = true) &&
        Checkin.deleteOne(item.id).finally(async () => {
          await this.updateCheckins()
        })
    },
    async handleSaveCheckin(checkin) {
      this.dialog = false
      this.loading = true
      try {
        if (checkin.id) {
          await Checkin.put(checkin)
        } else {
          await Checkin.post(checkin)
        }
        await this.updateCheckins()
        notify("success", "Sauvegardé")
      } catch (error) {
        notify("error", "Erreur lors de la sauvegarde")
      } finally {
        this.loading = false
      }
    },
    async updateCheckins() {
      if (!this.student_course_id) {
        return
      }
      // Clear stale records from store before fetching fresh data
      Checkin.delete((checkin) => checkin.student_course_id === this.student_course_id)
      await this.getDataFromApi()
      this.checkins = Checkin.query()
        .where("student_course_id", this.student_course_id)
        .with("student_course", (query) => {
          query.with("student").with("course")
        })
        .orderBy("date", "desc")
        .get()
      this.addEvamCodes()
    },
    addEvamCodes() {
      this.checkins.forEach((checkin) => {
        if (checkin?.student_course?.student?.assistant?.mandat === "EVAM") {
          checkin.displayType = checkin.statusLabel + checkin.evamCode
        } else {
          checkin.displayType = checkin.statusLabel
        }
      })
    },
  },
}
</script>
